import React from 'react';
import './CTA.css';
import { Link } from 'react-scroll';

const CTA = () => {
  return (
    <section className="cta-section" data-aos="fade-up">
      <h2 className="cta-heading">“What you don’t detect can cost you most.”</h2>
      <p className="cta-text">
        Mastitis silently impacts your dairy herd. Our solution is built to prevent it — smartly, sustainably, and simply.
      </p>
      <p className="cta-subtext">Curious how we do it?</p>
      
      <Link
        to="contact"
        smooth={true}
        duration={800}
        className="cta-button"
      >
        Contact Us to Know More
      </Link>
    </section>
  );
};

export default CTA;
